import React from 'react';
import Button from '../../../components/ui/Button';

const QuickFilters = ({ activeFilter, onFilterChange }) => {
  const filters = [
    { id: 'all', label: 'All Months', icon: 'Calendar' },
    { id: 'current', label: 'Current Month', icon: 'CalendarCheck' },
    { id: 'upcoming', label: 'Upcoming', icon: 'Clock' },
    { id: 'awareness', label: 'Awareness Campaigns', icon: 'Heart' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 mb-6 shadow-sm">
      <h3 className="text-sm md:text-base font-medium text-foreground mb-4">Quick Filters</h3>
      <div className="flex flex-wrap gap-2 md:gap-3">
        {filters?.map((filter) => (
          <Button
            key={filter?.id}
            variant={activeFilter === filter?.id ? 'default' : 'outline'}
            size="sm"
            onClick={() => onFilterChange(filter?.id)}
            iconName={filter?.icon}
            iconPosition="left"
          >
            {filter?.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickFilters;